import { render } from "./AlarmSettingsIndex.vue?vue&type=template&id=1a51f497"
import script from "./AlarmSettingsIndex.vue?vue&type=script&lang=js"
export * from "./AlarmSettingsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__